/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AttachIcon } from 'components/elements/Icons';
import { dateUtils } from 'utils';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentAttachmentItem({ fileName, uploadedBy, createdAt, onClick, isDisabled }) {
  const { t } = useTranslation('labels');
  const classes = useStyles();
  const updatedDateTime = useMemo(() => dateUtils.formatDateTimeString(createdAt), [createdAt]);

  const { salutation, firstName, lastName, currentUser } = uploadedBy || {};

  return (
    <div className={classes.appointmentAttachmentItem} data-testid="appointment-attachments-item">
      <div className={classes.attachmentInfoWrapper}>
        <div
          className={classes.attachmentName}
          onClick={() => {
            if (!isDisabled && onClick) onClick();
          }}
        >
          <Button className={classes.attachButton} variant="contained" color="secondary">
            <AttachIcon classes={classes.attachIcon} />
          </Button>
          <Typography className={classes.attachmentFileName} variant="body1" component="h6" color="secondary" noWrap>
            {fileName}
          </Typography>
        </div>
        {uploadedBy && (
          <Typography className={classes.attachmentProviderName} variant="body2" component="span">
            {currentUser ? t('you') : `${salutation}. ${firstName} ${lastName}`}
          </Typography>
        )}
      </div>
      <Typography className={classes.attachmentDate} variant="caption" component="span" noWrap>
        {updatedDateTime}
      </Typography>
    </div>
  );
}

AppointmentAttachmentItem.propTypes = {
  fileName: PropTypes.string.isRequired,
  uploadedBy: PropTypes.objectOf(PropTypes.any).isRequired,
  createdAt: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

AppointmentAttachmentItem.defaultProps = {
  onClick: null,
  isDisabled: false,
};

export default AppointmentAttachmentItem;
